import { useNavigate } from "react-router-dom";
import { GmailSettingsPage as GmailSettingsPageView } from "@/components/GmailSettingsPage";

export function GmailSettingsPage() {
  const navigate = useNavigate();

  return (
    <GmailSettingsPageView
      onOpenCandidates={(id) => navigate(`/settings/integrations/gmail/${id}/candidates`)}
      onBack={() => navigate("/bills")}
      onOpenEmailForwarding={() => navigate("/bills/email-forwarding")}
    />
  );
}
